import { logErrorMini } from '@/shared/services/service-logger/lib/log-error-mini';

import {
  isTGLink,
  openExternalLink,
  type OpenExternalOptions,
  openTelegramLink as openTelegramLinkBase,
  prepareLink,
} from './link-utils';

export const openTelegramLink = (url: string, options?: OpenExternalOptions) => {
  try {
    const resolvedURL = prepareLink(url);

    const opener = (url: string, options?: OpenExternalOptions) =>
      isTGLink(url) ? openTelegramLinkBase(url) : openExternalLink(url, options);

    opener(resolvedURL, options);
  } catch (err) {
    logErrorMini(err as Error, 'openTelegramLink', { url });
  }
};
